











import { Vue, Component, Prop } from "vue-property-decorator";
import { authModule } from "@/auth/modules";
import { appDrawerModule } from "@/app-drawer/modules";

@Component({
    name: "AppBar"
})
export default class AppBar extends Vue {
    private toggleAppDrawer() {
        appDrawerModule.toggleDrawer();
    }

    get profile() {
        const auth = authModule.item;
        return auth ? auth.profile : null;
    }

    get hasPicture() {
        if (!this.profile) {
            return false;
        }
        if (!this.profile.picture) {
            return false;
        }

        return true;
    }
}
